import React, { useState, useEffect } from 'react';
import './Navigation.css';
import { useLanguage } from '../LanguageContext';
import ukFlag from '../assets/uk-flag.svg';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { language, changeLanguage, t } = useLanguage();

  const menuItems = [
    { id: 'home', label: t('home') },
    { id: 'about', label: t('aboutUs') },
    { id: 'services', label: t('services') },
    { id: 'products', label: t('products') },
    { id: 'interest', label: 'Register Interest' },
    { id: 'contact', label: t('contactUs') }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      // Determine active section
      const sections = menuItems.map(item => ({
        id: item.id,
        element: document.getElementById(item.id)
      }));

      const scrollPosition = window.scrollY + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section.element && section.element.offsetTop <= scrollPosition) {
          setActiveSection(section.id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (sectionId === 'interest') {
      window.location.href = '/interest';
      setIsMobileMenuOpen(false);
      return;
    }

    const isMainPage = window.location.pathname === '/' || window.location.pathname === '/index.html';

    // If we are not on the main page (e.g., /interest), navigate there first
    if (!isMainPage) {
      window.location.href = `/#${sectionId}`;
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <button
          type="button"
          className="logo"
          onClick={() => scrollToSection('home')}
          aria-label="Go to home page"
        >
          <img 
            src={isScrolled ? '/assets/HonouredTech.png' : '/assets/HonouredTech_w.png'} 
            alt="HonouredTech" 
            className="logo-img" 
          />
        </button>
        <button className="hamburger" onClick={toggleMobileMenu} aria-label="Toggle menu">
          <span className={isMobileMenuOpen ? 'open' : ''}></span>
          <span className={isMobileMenuOpen ? 'open' : ''}></span>
          <span className={isMobileMenuOpen ? 'open' : ''}></span>
        </button>
        <ul className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          {menuItems.map(item => (
            <li key={item.id}>
              <button
                className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => scrollToSection(item.id)}
              >
                {item.label}
              </button>
            </li>
          ))}
          <li>
            <div className="language-switcher" aria-label="Language switcher">
              <button
                type="button"
                className={`lang-flag-button ${language === 'en' ? 'active' : ''}`}
                onClick={() => changeLanguage('en')}
                title="English"
                aria-label="Switch to English"
              >
                <img src={ukFlag} alt="" className="flag-icon" aria-hidden="true" />
              </button>
              <button
                type="button"
                className={`lang-flag-button ${language === 'ar' ? 'active' : ''}`}
                onClick={() => changeLanguage('ar')}
                title="العربية"
                aria-label="Switch to Arabic"
              >
                <span className="flag-icon flag-icon-uae" aria-hidden="true"></span>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
